import { SavedFilterStructure } from '@/Atomic/Organisms/FilterBuilder'
import { DataClassName } from '@/Data/const'

const LIST_OBJECT_FIELD = 'entityType'

const isListEntity = (entityName: string) =>
  entityName.toLowerCase() === DataClassName.LIST.toLowerCase()

export const removeListObjectFilterConditions = (
  entityName: string,
  filter: SavedFilterStructure,
): SavedFilterStructure => {
  if (!isListEntity(entityName)) return filter

  return {
    or: filter.or
      .map((group) => ({
        and: group.and.filter(
          (condition) => condition.field !== LIST_OBJECT_FIELD,
        ),
      }))
      .filter((group) => group.and.length > 0),
  }
}
